module.exports = __webpack_public_path__ + "img/imagemSifilis.bce021eb.jpg";